// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"758":"08f7bdbb","991":"fd0a9bd4"}[chunkId] + ".chunk.css";
};